import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomModal from "./CustomModal";
import AuthInput from "../Input/AuthInput";
import AuthTextArea from "../Input/AuthTextArea";
import AddingLightLoader from "../Loaders/AddingLightLoader";
import { ErrorToast, SuccessToast, WarningToast } from "../../utils/ShowToast";
import { CreateLoanPaymentApi } from "../../ApiRequests";
import AuthBtn from "../Buttons/AuthBtn";
import PaymentAccountSelector from "../Selector/PaymentAccountSelector";
import { fetchAccounts } from "../../store/Slices/AccountSlice";
import { fetchLoanLog, fetchLoans } from "../../store/Slices/LoanSlice";
import { getLoanBalance } from "../../utils/LoanConverter";
import { toLocalYmd } from "../../utils/dateTime";

const userData = JSON.parse(localStorage.getItem("user")) || {};
const { branchId = "" } = userData;

const AddLoanPaymentModal = ({ open, setOpen, loan, onSuccess }) => {
  const [amount, setAmount] = useState("");
  const [desc, setDesc] = useState("");
  const [curDate, setCurDate] = useState(
    toLocalYmd()
  );
  const [selectedAccount, setSelectedAccount] = useState("");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const AccountState = useSelector((state) => state.AccountState);

  const balance = getLoanBalance(loan);

  useEffect(() => {
    if (!open) return;
    dispatch(fetchAccounts());
  }, [open, dispatch]);

  useEffect(() => {
    if (!open || selectedAccount?._id) return;
    const accounts = Array.isArray(AccountState.data) ? AccountState.data : [];
    const cash =
      accounts.find(
        (a) => String(a.account_name || "").toUpperCase() === "CASH"
      ) || accounts[0];
    if (cash) setSelectedAccount(cash);
  }, [open, selectedAccount, AccountState.data]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const parsed = Number(amount);

    if (!parsed || parsed <= 0) WarningToast("Enter valid amount");
    else if (parsed > balance) WarningToast(`Max repayment is Rs ${balance}`);
    else if (!selectedAccount?._id) WarningToast("Select account");
    else {
      try {
        const response = await CreateLoanPaymentApi(loan._id, {
          amount: parsed,
          accountId: selectedAccount._id,
          branchId,
          date: curDate,
          desc,
        });
        if (response.data.success) {
          SuccessToast("Repayment recorded");
          setOpen(false);
          setAmount("");
          setDesc("");
          dispatch(fetchAccounts());
          dispatch(fetchLoans());
          dispatch(fetchLoanLog());
          onSuccess?.();
        } else {
          ErrorToast(response.data.error?.msg);
        }
      } catch (err) {
        ErrorToast(err.response?.data?.error?.msg || "Failed to record payment");
      }
    }
    setLoading(false);
  };

  if (!loan?._id) return null;

  return (
    <CustomModal open={open} setOpen={setOpen}>
      <div className="pb-8">
        <h1 className="w-full text-center font-[700] text-2xl py-6">
          Record repayment
        </h1>
        <p className="text-center text-sm text-inkSecondary mb-4">
          {loan.partyName} · Remaining Rs {balance.toLocaleString("en-PK")}
        </p>
        <div className="flex flex-col gap-y-4 px-10">
          <PaymentAccountSelector
            label="Receive repayment into"
            selectedAccount={selectedAccount}
            setSelectedAccount={setSelectedAccount}
          />
          <AuthInput
            label="Amount"
            Type="number"
            Value={amount}
            setValue={setAmount}
          />
          <AuthInput label="Date" Type="date" Value={curDate} setValue={setCurDate} />
          <AuthTextArea label="Notes" Value={desc} setValue={setDesc} />
        </div>
        <div className="flex justify-center gap-x-2 mt-5">
          {loading ? (
            <AddingLightLoader />
          ) : (
            <>
              <AuthBtn title="Save" onSubmit={onSubmit} type={1} />
              <AuthBtn title="Cancel" onSubmit={() => setOpen(false)} type={2} />
            </>
          )}
        </div>
      </div>
    </CustomModal>
  );
};

export default AddLoanPaymentModal;
